var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"info-table"},[_c('tr',[_c('th',[_vm._v("Admin")]),_c('td',[_vm._v("Full access with all administrative privileges")])]),_c('tr',[_c('th',[_vm._v("Manager")]),_c('td',[_vm._v("Access to view the performance and manage the assigned businesses")])])])
}]

export { render, staticRenderFns }